<template>
  <div class="flex shift_info" v-if="$myShift || $ShiftsToActivate">
    <div>
      <p><strong>{{ $myShift && $myShift.shift && $myShift.shift.title || 'Не активный' }}</strong></p>
      <p class="title">Моя смена</p>
    </div>
    <div class="ml-2">
      <v-popover
        v-if="$myShift"
        class=""
        popoverClass="work_shift_popover"
        popoverInnerClass="popover_content"
        trigger="hover"
        :auto-hide="true">
        <div class="popover_icon">
          <i class="icon-fa icon-fa-info"></i>
        </div>
        <template slot="popover">
          <div class="">
            <p v-if="$myShift">Активировна с: <strong>{{ moment($myShift.created_at, 'HH:mm') }}</strong></p>
            <p>Мои доступы</p>
            <div>
              <p v-for="(access, project) in $orderAccess">
                <strong>{{
                    project === 'all' ? 'Все проекты' : $AllProjects[project] && $AllProjects[project].name || 'Не определен'
                  }}</strong>:
                {{
                  access.all ? 'Все направления' : $AllCities[Object.keys(access)[0]] && $AllCities[Object.keys(access)[0]].name || 'не определен'
                }}
              </p>
            </div>
            <p>Активные <strong>SIP</strong></p>
            <div>
              <p v-for="(sip) in $PhoneNumbers.sipAccounts">{{ printSip(sip.sip_login) }}</p>
            </div>
            <div class="text-right">
              <button @click="closeShift" class="btn btn-outline-warning">Закрыть смену</button>
            </div>
          </div>
        </template>
      </v-popover>
      <v-popover
        v-if="!$myShift && $ShiftsToActivate && getActualShift().length"
        class=""
        popoverClass="work_shift_activation_popover"
        popoverInnerClass="popover_content"
        trigger="hover"
        :open="openPopover"
        :auto-hide="false">
        <div class="">
          <!--          <i class="icon-fa icon-fa-info"></i>-->
        </div>
        <template slot="popover">
          <div class="">
            <template v-if="shiftsForSelect && shiftsForSelect.length">
              Выберите смену для активации!
            </template>
            <!--            <template v-else>-->
            <!--              На данное время нет активных смен для Вас!-->
            <!--            </template>-->
            <div>
              <div v-for="shift in shiftsForSelect">
                <LoadingButton
                  :title="shift.title + ` (${shift.start} - ${shift.end})`"
                  className="btn btn-default"
                  :loading="loading"
                  color="#02a2f8"
                  :onClick="() => activateShift(shift)"
                />
              </div>
            </div>
          </div>
        </template>
      </v-popover>
    </div>
  </div>
</template>

<script>

import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton"
import api from "@/api"
import store from "@/store";

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      openPopover: true,
      shiftsForSelect: null,
    }
  },
  computed: {
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    },
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $PhoneNumbers() {
      return this.$store.getters["user/phoneNumbers"];
    },
    $AllowedPhoneNumbers() {
      return this.$store.getters["user/allowedPhoneNumbers"];
    },
    $ShiftsToActivate() {
      return this.$store.getters["user/shiftsToActivate"];
    },
    $UpdateActiveWorkingShift() {
      return this.$store.getters["user/updateActiveWorkingShift"];
    },
    $myShift() {
      return this.$store.getters["user/myShift"];
    },
    $AllowedShifts() {
      return this.$store.getters["user/allowedShifts"];
    }
  },
  mounted() {
    this.updateActiveWorkingShift();
  },
  watch: {
    $UpdateActiveWorkingShift: {
      handler: function (val, oldVal) {
        if (val) {
          this.updateActiveWorkingShift();
        }
      },
      deep: false
    }
  },
  methods: {
    printSip(sip) {
      console.log(sip);
      return sip.split('sip:')[1];
    },
    async updateActiveWorkingShift() {
      // console.log('update shift');
      console.log('shift updated');
      if (this.$myShift && this.$myShift.shift) {
        const timeShift = this.$myShift.shift.end.split(':');
        const endTime = new Date();
        // console.log(timeShift, endTime);
        endTime.setHours(timeShift[0], +timeShift[1] + 30, timeShift[2]);
        // console.log(endTime)
        if (new Date() > endTime) {
          const {data} = await api.index('users/updateShift/' + this.$myShift.id + '?action=deactivate');
          if (data.success) {
            toastr["success"]("Смена закрыта");
          }
          console.log('call update');
          this.updateShifts();
        } else {
          this.openPopover = false;
        }
      } else if (!this.$myShift && this.$AllowedShifts.length >= 1) {
        this.updateShifts();
      }
      this.$store.dispatch('user/setUpdateActiveWorkingShift', false);
      if (!this.$myShift) {
        this.openPopover = true;
      }
    },
    updateShifts() {
      const now = new Date;
      const shifts = this.$AllowedShifts.reduce((acc, s) => {
        const end = s.end.split(':');
        const start = s.start.split(':');
        const startTime = new Date();
        startTime.setHours(start[0], +start[1] - 30, start[2]);
        const endTime = new Date();
        endTime.setHours(end[0], +end[1], end[2]);
        if (now > startTime && now < endTime) {
          acc.push(s);
        }
        return acc;
      }, []);
      if (shifts.length > 0) {
        this.$store.dispatch('user/setShiftsToActivate', shifts);
        this.shiftsForSelect = shifts;
      }
      // console.log(shifts);
    },
    async closeShift() {
      const {data} = await api.index('users/updateShift/' + this.$myShift.id + '?action=deactivate');
      if (data.success) {
        toastr["success"]("Смена закрыта");
        this.updateShifts();
      }
    },
    async activateShift(shift) {
      if (this.loading) return;
      this.loading = true;
      const {data} = await api.index('/users/activateShift/' + shift.id);
      if (data.success) {
        this.openPopover = false;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    getActualShift() {
      let shifts = [];

      this.$ShiftsToActivate.forEach((s) => {
        const start = s.start.split(':');
        const end = s.end.split(':');
        const timeStart = moment().set('hour', start[0]).set('minute', (start[1] - 5));
        const timeEnd = moment().set('hour', end[0]).set('minute', (end[1] - 5));
        const now = moment().unix();
        if (s.id !== (this.$myShift && this.$myShift.shift && this.$myShift.shift.id) && now > timeStart.unix() && now < timeEnd.unix()) {
          shifts.push(s);
        }
      })
      return shifts;
    },
    sortPhone() {
      return _.orderBy(this.$AllowedPhoneNumbers, 'description');
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.popover_icon i {
  font-size: 21px;
  vertical-align: middle;
}

.popover_icon {
  margin-top: 2px;
  background-color: #02a2f8;
  padding: 5px 13px;
  border-radius: 7px;
  color: white;
  cursor: pointer;
}

.title {
  font-size: 10px;
  margin-bottom: 0;
}
</style>
<style>
.work_shift_activation_popover {
  max-width: max-content;
}

.work_shift_popover {
  /*min-width: 350px;*/
  max-width: max-content;
}

.popover_content {
  padding: 20px;
}
</style>
